export function getIcon(name) {
  return `<svg class='icon icon-${name}' aria-hidden="true"><use xlink:href="#icon-${name}"></use></svg>`;
}

export function getButton(text, className, icon) {
  return `
    <button type="button" class="${className}">
      <span class="sr-only">${text}</span>
      ${getIcon(icon)}
    </button>
  `;
}
